import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import DataTable from '../../../components/table/DataTable';
import { DocumentOptionalField, InvoiceBaseInputs } from '../../../types/Invoice';
import { toast } from 'react-toastify';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { columns } from '../../../components/columns/Company/DocumentOptionalFieldsColumns';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { useLoading } from '../../../context/loadingContext';
import { useTranslation } from '../../../context/translationContext';
interface Props {
  document: InvoiceBaseInputs;
  mutate?: () => void;
}

/**
 * Invoice side panel for managing optional fields
 */
export const InvoiceSidePanelTabOptionalFields = ({ document, mutate }: Props) => {
  const { id: documentId } = useParams();
  const { company } = useCurrentCompany();
  const { documentLang } = useTranslation();
  const [optionalFields, setOptionalFields] = useState<DocumentOptionalField[] | null>(null);
  const { startLoading, stopLoading } = useLoading();

  useEffect(() => {
    fetchOptionalFields();
  }, [company, documentLang]);

  /**
   * Loads optional fields for current document
   */
  const fetchOptionalFields = async () => {
    if (!company) return;
    const req = `?parentId=${company.id}`;
    const response = await http.apiGet({
      url: `${apiUrl.OPTIONAL_FIELD_LIST}${req}`,
    });
    if (response?.data)
      setOptionalFields(
        response?.data.filter(
          (x: DocumentOptionalField) =>
            !!x.isActive && x.language === documentLang?.toLocaleLowerCase(),
        ),
      );
  };

  /**
   * Creates / removes link (optional field to document)
   * @param id - id of link (to remove) or id of optional field (to create link)
   */
  const onLinkOptionalFieldToDocument = async (id: number, checked: boolean) => {
    try {
      startLoading();
      if (checked) {
        // link
        const response = await http.apiPost({
          url: `${apiUrl.ACCOUNTING_DOCUMENT_LINK_OPTIONAL_FIELD}?optionalFieldId=${id}&documentId=${documentId}`,
        });
        if (response?.status === 200) {
          stopLoading();
          toast.success('Success!');
          mutate && mutate();
        }
      } else {
        // unlink
        const response = await http.apiDelete({
          url: `${apiUrl.ACCOUNTING_DOCUMENT_UNLINK_OPTIONAL_FIELD}?optionalFieldOnAccountingDocumentId=${id}`,
        });
        if (response?.status === 204) {
          stopLoading();
          toast.success('Success!');
          mutate && mutate();
        }
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  return (
    <DataTable
      data={optionalFields}
      columns={columns(onLinkOptionalFieldToDocument, document.optionalFields ?? [])}
    />
  );
};
